"use client";

import ImageContainer from "../ImageContainer";
import { Autoplay, FreeMode, Grid, Navigation, Pagination } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

export default function SwiperImage(props: any) {
  return (
    <>
      <Swiper
        grabCursor={true}
        navigation={true}
        slidesPerView={1}
        loop={true}
        pagination={{
          clickable: true,
          type: "bullets",
          bulletClass: "custom-bullet",
          bulletActiveClass: "custom-bullet-active",
        }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, FreeMode, Grid, Pagination, Navigation]}
      >
        {props.slides.map((slide: any, index: number) => {
          return (
            <SwiperSlide key={index}>
              <ImageContainer
                image={`/${slide.img}`}
                width={500}
                height={500}
                imageStyle={"w-full h-auto mb-16"}
                alt={slide.alt}
                title={slide.title}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
}
